const ENVIRONMENTS = {
  dev: {
    ccBaseUrl: "https://comm.clairedev.nl",
    clientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    envName: "dev",
    searchEnv: "dev",
    storageI18n: "https://storage.googleapis.com/clairei18n",
    webSocketEndpoint: "wss://notifier.clairedev.nl",
    gaTrackingCode: "UA-114415392-2",
    sentryURL: "https://16dd86da404141d4917f1ad2019e61bb@sentry.io/1391180",
    zohoASAP: "https://desk.zoho.eu/portal/api/web/asapApp/172650000043833003?orgId=20098974504",
    wheelTireOrderPortalURL: "https://test-011.webdis.nl",
    bandenExpressOrderPortalURL: "https://test-081.bexweb.nl",
    v8BaseUrl: "https://v8.clairedev.nl",
    tyreteamBaseURL: "https://clairedev.nl/api/tyreteam/v1",
    shareboxBaseURL: "https://clairedev.nl/api/sharebox/v1",
    dmsv3BaseUrl: "https://clairedev.nl/api/dmsv3/v1",
    twilioBaseUrl: "https://clairedev.nl/api/twilio/v1",
    authBaseUrl: "https://clairedev.nl/api/auth/v1",
    dcBaseUrl: "https://clairedev.nl/api/desk/v1",
    appointmentApiBase: "https://clairedev.nl/api/appointment/v1",
    reportsBaseUrl: "https://clairedev.nl/api/report/v1",
    dealerBaseUrl: "https://clairedev.nl/api/dealer/v1",
    carBaseUrl: "https://clairedev.nl/api/car/v1",
    keylockerBase: "https://clairedev.nl/api/keylocker/v1",
    acsesBaseUrl: "https://clairedev.nl/api/acses/v1",
    kioskBaseUrl: "https://clairedev.nl/api/kiosk/v1",
    importerBaseUrl: "https://clairedev.nl/api/importer/v3",
    customComBaseUrl: "https://clairedev.nl/api/customcom/v1",
    systemBase: "https://clairedev.nl/api/system/v1",
    exactBase: "https://clairedev.nl/api/exact/v1",
    tyreMotionBase: "https://clairedev.nl/api/tyremotion/v1",
    deskComBase: "https://clairedev.nl/api/desk/v1",
    dmsWeb: "https://clairedev.nl/api/dmsaccessor/v1",
  },
  local: {
    ccBaseUrl: "https://comm.clairedev.nl",
    clientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    envName: "dev",
    searchEnv: "dev",
    storageI18n: "https://storage.googleapis.com/clairei18n",
    webSocketEndpoint: "wss://notifier.clairedev.nl",
    gaTrackingCode: "UA-114415392-2",
    sentryURL: "https://16dd86da404141d4917f1ad2019e61bb@sentry.io/1391180",
    zohoASAP: "https://desk.zoho.eu/portal/api/web/asapApp/172650000043833003?orgId=20098974504",
    keylockerBase: "https://clairedev.nl/api/keylocker/v1",
    acsesBaseUrl: "https://clairedev.nl/api/acses/v1",
    kioskBaseUrl: "https://clairedev.nl/api/kiosk/v1",
    importerBaseUrl: "https://clairedev.nl/api/importer/v3",
    exactBase: "https://clairedev.nl/api/exact/v1",
  },
  prod: {
    ccBaseUrl: "https://mycarcheck.pro",
    clientID: "674901036874-hrv3lhqlkp3b0uh8lhoaj0hlmrqd37it.apps.googleusercontent.com",
    envName: "prod",
    searchEnv: "prod",
    storageI18n: "https://storage.googleapis.com/clairei18n-prod",
    webSocketEndpoint: "wss://notifier.claireit.com",
    gaTrackingCode: "UA-114415392-1",
    sentryURL: "https://16dd86da404141d4917f1ad2019e61bb@sentry.io/1391180",
    zohoASAP: "https://desk.zoho.eu/portal/api/web/asapApp/99375000043916017?orgId=20081393645",
    wheelTireOrderPortalURL: "https://www.webdis.nl",
    bandenExpressOrderPortalURL: "https://www.bexweb.nl",
    v8BaseUrl: "https://v8.claireit.com",
    tyreteamBaseURL: "https://claireit.com/api/tyreteam/v1",
    shareboxBaseURL: "https://claireit.com/api/sharebox/v1",
    dmsv3BaseUrl: "https://claireit.com/api/dmsv3/v1",
    twilioBaseUrl: "https://claireit.com/api/twilio/v1",
    authBaseUrl: "https://claireit.com/api/auth/v1",
    dcBaseUrl: "https://claireit.com/api/desk/v1",
    appointmentApiBase: "https://claireit.com/api/appointment/v1",
    reportsBaseUrl: "https://claireit.com/api/report/v1",
    dealerBaseUrl: "https://claireit.com/api/dealer/v1",
    carBaseUrl: "https://claireit.com/api/car/v1",
    keylockerBase: "https://claireit.com/api/keylocker/v1",
    acsesBaseUrl: "https://claireit.com/api/acses/v1",
    kioskBaseUrl: "https://claireit.com/api/kiosk/v1",
    importerBaseUrl: "https://claireit.com/api/importer/v3",
    customComBaseUrl: "https://claireit.com/api/customcom/v1",
    systemBase: "https://claireit.com/api/system/v1",
    exactBase: "https://claireit.com/api/exact/v1",
    tyreMotionBase: "https://claireit.com/api/tyremotion/v1",
    deskComBase: "https://claireit.com/api/desk/v1",
    dmsWeb: "https://claireit.com/api/dmsaccessor/v1",
  },
};

const ENV = ENVIRONMENTS[process.env.REACT_APP_ENV];

export default ENV;
